import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { IsLoggedIn, Selectors } from '@grandvisionhq/auth';
import { useIntl, useSelector } from '@grandvisionhq/state';
import 'throttle-debounce';
import '@grandvisionhq/common';
import '@grandvisionhq/graphql';
import '../../operations/queries/get-place-by-id.js';
import '../../operations/queries/get-stores-by-distance.js';
import '../../operations/queries/get-store-by-id.js';
import '../../operations/queries/get-store-details.js';
import '../../operations/queries/get-nearest-stores.js';
import '../../operations/queries/get-preferred-store.js';
import '../../operations/queries/get-preferred-store-id.js';
import '../../operations/queries/get-preferred-store-code.js';
import '../../operations/queries/stores-search.js';
import '../../types.js';
import '@grandvisionhq/fun-store-filters';
import useGetPreferredStoreId from '../../hooks/api/use-get-preferred-store-id.js';
import useUpdatePreferredStore from '../../hooks/api/use-update-preferred-store.js';
import '@grandvisionhq/locations';
import '@grandvisionhq/utils';
import '../../context/StoreFinder/context.js';
import 'lodash/deburr';
import '../../context/StoreFinderSlots/context.js';
import usePreferredStore from '../../hooks/use-preferred-store.js';
import PreferredStoreButton from './PreferredStoreButton.js';

const PreferredStoreButtonContainer = ({ storeId , storeName  })=>{
    const { getLabel  } = useIntl();
    const userId = useSelector(Selectors.getUserId);
    const isLoggedIn = useSelector(Selectors.isLoggedIn);
    const { onHandlePreferredStoreChange  } = usePreferredStore(storeName);
    const { updatePersonalDetails , data: mutatedData , loading: isUpdating ,  } = useUpdatePreferredStore({
        onCompleted: ()=>onHandlePreferredStoreChange(isUpdating, true, 'stores.storeDetailsRoot.preferredStoreUpdate.success')
        ,
        onError: (_, label)=>{
            onHandlePreferredStoreChange(isUpdating, false, label);
        }
    });
    const { data , loading  } = useGetPreferredStoreId();
    if (loading || !userId || !isLoggedIn) {
        return null;
    }
    const { globalStoreId: preferredStoreId  } = data !== null && data !== void 0 ? data : {};
    const isPreferredStore = storeId === preferredStoreId || storeId === (mutatedData === null || mutatedData === void 0 ? void 0 : mutatedData.globalStoreId);
    const onClick = ()=>updatePersonalDetails(storeId, userId)
    ;
    return /*#__PURE__*/ React.createElement(PreferredStoreButton, {
        labels: {
            preferredStore: getLabel('stores.preferredStoreButton.active'),
            setPreferredStore: getLabel('stores.preferredStoreButton.set')
        },
        onClick: onClick,
        selected: isPreferredStore
    });
};
var PreferredStoreButtonContainer$1 = ((props)=>/*#__PURE__*/ React.createElement(IsLoggedIn, null, /*#__PURE__*/ React.createElement(PreferredStoreButtonContainer, swcHelpers.extends({}, props)))
);

export { PreferredStoreButtonContainer$1 as default };
//# sourceMappingURL=PreferredStoreButtonContainer.js.map
